module.exports = __webpack_public_path__ + "static/media/04 - Pickup B.4969d854.png";